var map = {
	"./de.json": 882,
	"./en.json": 883,
	"./es.json": 884,
	"./fr.json": 885,
	"./it.json": 886,
	"./ja.json": 887,
	"./nl.json": 888,
	"./pt.json": 889,
	"./zh.json": 890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 593;